import React, { useState } from "react";
import { InteractiveMapCooperative } from "./map"; 
import { useGetAgrCooperativesByYearQuery } from "./api";
import { DistributionCooperativesTable } from "./cooperativesbycontry";
import { Button } from "antd";
import { useTranslation } from "react-i18next";
import ReportDepartmentMechModal from "../../../pages/admin/mechanization/reportDepartmentMech/ReportDepartmentMechModal";
import { useGetReportByCooperativesMutation } from "../../../redux/api/mechanization/reportDepartmentMechApi"; 
import { useGetTerritorialUnitsPolygonsListQuery } from "../../../components/api";
import style from './style.module.css';
import { PreloaderSvg } from "../../preloaderSvg/PreloaderSvg";
import { EntTerritorialUnitsFilterPoligons } from "../../../components/api/territorialUnitsFilterPoligons";

export const Cooperatives = () => {
  const {t} = useTranslation();
  const [getCooperativeReport] = useGetReportByCooperativesMutation();
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear().toString());
  const [showModal, setShowModal] = useState<boolean>(false);
  const [ showReportModal, setShowReportModal ] = useState<boolean>(false);

  const { data: polygonsData, isLoading: polygonsLoading } = useGetTerritorialUnitsPolygonsListQuery(new EntTerritorialUnitsFilterPoligons({ 
    page: 1, 
    size: 60,
    type: [ "REGION", "AREA", "CITY_OF_REPUBLICAN_SIGNIFICANCE"],
  }));

  const handleYearChange = (value: number | null) => {
    setSelectedYear(value?.toString() || new Date().getFullYear().toString());
  };

  const getReport = async (payload: {languageEnum: string }): Promise<Blob> => {
    return await getCooperativeReport(payload).unwrap();
  };

  const { data, isLoading } = useGetAgrCooperativesByYearQuery({ year: selectedYear });
  
  const mapPoints = data?.res?.regions?.reduce((acc: any[], region: any) => {
    return acc.concat(region.cooperatives || []);
  }, []) || [];


  const tablePoints = data?.res?.regions || [];

  if (isLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <PreloaderSvg/>
      </div>
    );
  }

  return (
    <div className={style.container}>
    <div className={style.container_inner}>
      <div className={style.title}>
        <div className={style.title_header}>
          <h1>{t('Agricultural cooperatives')}</h1>
          <Button 
            style={{marginLeft: '5px'}} 
            type="primary" 
            icon={<img src="../report.svg" alt="Plus Icon" style={{ width: '16px', height: '16px' }} />} 
            onClick={() => setShowReportModal(true)}
          >
            {t('general.generate_report')}
          </Button>
        </div>
        <ReportDepartmentMechModal
          type={ 'cooperatives' }
          title={ t('reports.report_by_cooperatives') }
          getReport={ getReport }

          show={ showReportModal }
          onHide={ () => setShowReportModal(false) }
        />
        <div className={style.title_inner}>
          <img src="./homeicon.svg" alt="home" />
          <p>{t('Home')}</p>
          <img src="./arrowright.svg" alt="arrow" />
          <p>{t('Mechanization and innovations')}</p>
          <img src="./arrowright.svg" alt="arrow" />
          <span className={style.namepage}>{t('Agricultural cooperatives')}</span>

        </div>
      </div>
      <InteractiveMapCooperative 
        latitude={41.5089324} 
        longitude={74.724091}
        polygonsData={polygonsData}
        cooperativesPoints={mapPoints}
        selectedYear={selectedYear}
        onYearChange={handleYearChange}
      />
      <DistributionCooperativesTable points={tablePoints} />
    </div>
    </div>
  );
};
